import { Route } from '@angular/router';
import { authGuard, loginGuard } from './auth';
import { parameterTypeGuard } from './auth/parameter-type.guard';
import { ReportPageComponent } from './data-entry/pages/report-page/report-page.component';
import { NotFoundPage } from './not-found.page';
export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () => import('./auth/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./auth/components/login.component').then((m) => m.LoginComponent),
      },
    ],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./auth/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./auth/components/forgot-password.component').then((m) => m.ForgotPasswordComponent),
      },
    ],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./auth/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./auth/components/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
    ],
  },
  {
    path: 'air',
    canActivate: [authGuard, parameterTypeGuard],
    canActivateChild: [authGuard, parameterTypeGuard],
    loadComponent: () => import('./data-entry/layout/layout.component').then((m) => m.LayoutComponent),
    data: {
      parameterType: 'air',
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./data-entry/data-entry.component').then((m) => m.DataEntryComponent),
      },
    ],
  },
  {
    path: 'water-discharge',
    canActivate: [authGuard, parameterTypeGuard],
    canActivateChild: [authGuard, parameterTypeGuard],
    loadComponent: () => import('./data-entry/layout/layout.component').then((m) => m.LayoutComponent),
    data: {
      parameterType: 'water_discharge',
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./data-entry/data-entry.component').then((m) => m.DataEntryComponent),
      },
    ],
  },
  {
    path: 'water-intake',
    canActivate: [authGuard, parameterTypeGuard],
    canActivateChild: [authGuard, parameterTypeGuard],
    loadComponent: () => import('./data-entry/layout/layout.component').then((m) => m.LayoutComponent),
    data: {
      parameterType: 'water_intake',
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./data-entry/data-entry.component').then((m) => m.DataEntryComponent),
      },
    ],
  },
  {
    path: 'residue',
    canActivate: [authGuard, parameterTypeGuard],
    canActivateChild: [authGuard, parameterTypeGuard],
    loadComponent: () => import('./data-entry/layout/layout.component').then((m) => m.LayoutComponent),
    data: {
      parameterType: 'residue',
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./data-entry/data-entry.component').then((m) => m.DataEntryComponent),
      },
    ],
  },
  {
    path: 'energy',
    canActivate: [authGuard, parameterTypeGuard],
    canActivateChild: [authGuard, parameterTypeGuard],
    loadComponent: () => import('./data-entry/layout/layout.component').then((m) => m.LayoutComponent),
    data: {
      parameterType: 'energy',
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./data-entry/data-entry.component').then((m) => m.DataEntryComponent),
      },
    ],
  },
  {
    path: 'report',
    canActivate: [authGuard],
    component: ReportPageComponent,
  },
  {
    path: '',
    redirectTo: 'air',
    pathMatch: 'full',
  },
  { path: '**', component: NotFoundPage },
];
